import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const checkoutTopUpSession = (data) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const URL = routes.CHECKOUT_TOPUP_SESSION;
    
    axios
      .post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default checkoutTopUpSession;